import React, { Component, useState } from "react";
import Closed from "./Closed";
import Live from "./Live";
import ReusableTabs from "../../../pages/ReusableTabs";

const TrackerTab = () => {
    const [activeTab, setActiveTab] = useState(0);

    const tabs = [
        { label: 'Live', component: <Live /> },
        { label: 'Closed', component: <Closed /> },
    ];

    return (
        <ReusableTabs 
            tabs={tabs}
            defaultTab={0}
            activeTab={activeTab}        
            onTabChange={setActiveTab}   
            panelStyles={{ padding: '16px' }}
        />
    );
}

export default TrackerTab;